import {useState, useCallback} from 'react'
import CustomBox from '../../../components/common/CustomBox'
import {StyledSelect, StyledDiv, StyledMenuItem} from '../../UserManagement/UserManagementStyle'
import PropTypes from 'prop-types'

const columnFirstName = 'FIRST_NAME'
const columnLastUpdated = 'LAST_UPDATED_DATE_TIME'
const columnEndDate = 'END_DATE'

const parseDate = (dateStr) => {
  if (!dateStr || dateStr === 'Indefinite' || typeof dateStr !== 'string') {
    return new Date(9999, 11, 31)
  }

  const parts = dateStr.split('/').map((part) => Number.parseInt(part, 10))
  if (parts.length === 3 && parts.every((part) => !Number.isNaN(part))) {
    return new Date(parts[2] + 2000, parts[0] - 1, parts[1])
  } else {
    throw new Error(`Invalid date`)
  }
}

export const sortTypesMap = {
  newest: {
    key: 'newest',
    label: 'Newest',
    func: ({data}) => {
      const sortedData = [...data].sort((a, b) => (a?.[columnLastUpdated] < b?.[columnLastUpdated] ? 1 : -1))
      return sortedData
    }
  },
  atoz: {
    key: 'atoz',
    label: 'Name A-Z',
    func: ({data}) => {
      const sortedData = [...data].sort((a, b) =>
        a?.[columnFirstName].toLowerCase() > b?.[columnFirstName].toLowerCase() ? 1 : -1
      )
      return sortedData
    }
  },
  ztoa: {
    key: 'ztoa',
    label: 'Name Z-A',
    func: ({data}) => {
      const sortedData = [...data].sort((a, b) =>
        a?.[columnFirstName].toLowerCase() < b?.[columnFirstName].toLowerCase() ? 1 : -1
      )
      return sortedData
    }
  },
  expiring: {
    key: 'expiring',
    label: 'Expiring',
    func: ({data}) => {
      const sortedData = [...data].sort((a, b) => {
        const dateA = parseDate(a?.[columnEndDate])
        const dateB = parseDate(b?.[columnEndDate])
        return dateA - dateB
      })
      return sortedData
    }
  }
}

export const SortComponent = ({setSortedData, data, view, isClientComponent}) => {
  SortComponent.propTypes = {
    setSortedData: PropTypes.func.isRequired,
    data: PropTypes.array.isRequired,
    view: PropTypes.string,
    isClientComponent: PropTypes.bool
  }
  const [label, setLabel] = useState('Newest')
  const [sortBy, setSortBy] = useState('newest')

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleChange = useCallback((event) => {
    setSortBy(event.target.value)
  })

  const sortApply = (sortKey) => {
    setLabel(sortTypesMap[sortKey].key)
    const sortedData = sortTypesMap[sortKey].func({data})
    setSortedData(sortedData)
  }

  return (
    <CustomBox display='flex' flexDirection='row' alignItems='center'>
      <StyledDiv id='select-label' aria-label={`Sort by-${label}`} data-testid='sortComponent'>
        Sort by &nbsp;
      </StyledDiv>
      <StyledSelect
        id='styled-select'
        data-testid='styled-select'
        variant='outlined'
        value={sortBy}
        onChange={handleChange}
        labelId='select-label'
        inputProps={{'aria-labelledby': 'styled-select'}}
      >
        {Object.entries(sortTypesMap)
          .filter(([key]) => !((view === 'archive' || isClientComponent) && key === 'expiring'))
          .map(([key, {label}]) => (
            <StyledMenuItem key={key} value={key} onClick={() => sortApply(key)} data-testid={key}>
              {label}
            </StyledMenuItem>
          ))}
      </StyledSelect>
    </CustomBox>
  )
}
